import {Component, OnInit} from '@angular/core';
import {TicketElements} from '../../../../../../projects/shared-lib/src/lib/models/ticket-elements';
import {TicketsService} from '../../../tickets.service';
import {AnalyticsService} from '../../../../shared/services/analytics.service';
import { NgStyle } from '@angular/common';
import { ClientTicketsSummaryComponent } from '../client-tickets-summary/client-tickets-summary.component';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'tw-client-tickets',
    templateUrl: './client-tickets.component.html',
    styleUrls: ['./client-tickets.component.css'],
    imports: [NgStyle, ClientTicketsSummaryComponent, TranslatePipe]
})
export class ClientTicketsComponent implements OnInit {
    tickets: TicketElements;

    constructor(private ticketService: TicketsService,
                private analyticsService: AnalyticsService) {
    }


    ngOnInit() {
        this.analyticsService.trackUpcomingTicketsView();
        this.ticketService.getUpcomingTickets().subscribe((tickets: TicketElements) => {
            this.tickets = tickets;
        });
    }
}
